// extracted by mini-css-extract-plugin
export var layoutContainer = "_db-0";
export var layoutContainerNoRounding = "_db-6";
export var layoutContainerOpen = "_db-5";
export var layoutContainerResizing = "_db-1";
export var mainContent = "_db-2";
export var resizeDivider = "_db-3";
export var slidePanel = "_db-4";